export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: (context) => import('~/plugins/i18n.js').then(m => m.default(context)),
  vueI18nLoader: false,
  locales: [{"name":"English","code":"en","file":"en.json"},{"name":"Deutsch","code":"de","file":"de.json"},{"name":"Srpski","code":"sr","file":"sr.json"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "/app/src/static/tickethead/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":true,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  loadLanguagesAsync: true,
  prefix_except_default: true,
  switchLocalePath: "/:lang/:route",
  normalizedLocales: [{"name":"English","code":"en","file":"en.json"},{"name":"Deutsch","code":"de","file":"de.json"},{"name":"Srpski","code":"sr","file":"sr.json"}],
  localeCodes: ["en","de","sr"],
}

export const localeMessages = {
  'en.json': () => import('../../static/tickethead/locales/en.json' /* webpackChunkName: "lang-en.json" */),
  'de.json': () => import('../../static/tickethead/locales/de.json' /* webpackChunkName: "lang-de.json" */),
  'sr.json': () => import('../../static/tickethead/locales/sr.json' /* webpackChunkName: "lang-sr.json" */),
}
